import {Component, Input} from '@angular/core';
import {TableModule} from 'primeng/table';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-hosting-details',
  standalone: true,
  imports: [CommonModule, TableModule],
  templateUrl: './hosting-details.component.html',
  styleUrl: './hosting-details.component.css'
})
export class HostingDetailsComponent {
  @Input() hostingData:any = {};
}
